 <template>
  <div class="mt-3 mt-sm-5 pt-5">
   <b-container> 
   <div class="psiContainer">
   <h4 class="font20 mb-4">Frequently Asked Questions</h4>
<div class="faqsContant">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <p block href="#" v-b-toggle.accordion1 class="mb-0 p-2">
          <span class="faqsWidth">What is PortfolioSmith?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion1" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon">PortfolioSmith is a powerful portfolio evaluation tool that utilizes cutting-edge algorithms to quickly analyze your stock portfolio. It helps you to easily identify any investing biases, stock selection errors, or portfolio management mistakes that may be holding you back. Not only that, it also provides precise guidance on how to avoid those mistakes and suggests changes to your portfolio, if needed. With PortfolioSmith, you can take the guesswork out of investing and achieve greater success in your financial goals.</p>
          </b-card-body>
        </b-collapse>

        <b-card-header header-tag="header" class="p-1" role="tab">
         <p block href="#" v-b-toggle.accordion2 class="mb-0 p-2"><span class="faqsWidth">Who is Analyzing my portfolio?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion2" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon">PortfolioSmith algorithmically evaluates your portfolio. Our smart algorithm incorporates hundreds of factors that an analyst or a seasoned investor would consider. While universal truths about investing remain constant, human views can be subjective and biased. PortfolioSmith removes such biases and delivers you an objective and unbiased evaluation.</p>
          </b-card-body>
        </b-collapse>



         <b-card-header header-tag="header" class="p-1" role="tab" v-if="!userDetails.isBrokerUser">
         <p block href="#" v-b-toggle.accordion3 class="mb-0 p-2"><span class="faqsWidth"> Why only 13 reports per quarter or 52 reports per year?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion3" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon"> Post-analysis is essential to the success of any investment strategy. The useful insights that you derive can help you take the necessary steps to safeguard your money and increase your wealth. However, analyzing your portfolio on a daily basis can be overwhelming and time-consuming. We believe that examining your portfolio once a week will provide you with sufficient and useful insights that will allow you to take further actions to enhance wealth generation. </p>
          </b-card-body>
        </b-collapse>


         <b-card-header header-tag="header" class="p-1" role="tab" v-if="!userDetails.isBrokerUser">
         <p block href="#" v-b-toggle.accordion4 class="mb-0 p-2"><span class="faqsWidth">What if I don't use all my 13 reports within 90 days?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion4" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon"> The monthly, quarterly, and yearly subscriptions are only valid for 30, 90, and 365 days, respectively. If you do not create the specified reports, they will expire/lapse at the end of your membership period. </p>
          
          </b-card-body>
        </b-collapse>


         <b-card-header header-tag="header" class="p-1" role="tab">
         <p block href="#" v-b-toggle.accordion5 class="mb-0 p-2"><span class="faqsWidth">How can I upload my transactions? </span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion5" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon"> You can upload your transactions in a CSV format as shown in the sample file. You can also upload your Zerodha Tradebook. Additionally, you can also add or delete transactions one by one manually.</p>
          </b-card-body>
        </b-collapse>



         <b-card-header header-tag="header" class="p-1" role="tab">
         <p block href="#" v-b-toggle.accordion6 class="mb-0 p-2"><span class="faqsWidth"> What is the rationale for recommendations?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion6" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon">Our stock ideas are based on the CANSLIM investing framework. The framework combines both fundamental and technical factors while making investing decisions.</p>
          </b-card-body>
        </b-collapse>



         <b-card-header header-tag="header" class="p-1" role="tab">
         <p block href="#" v-b-toggle.accordion7 class="mb-0 p-2"><span class="faqsWidth">Should we enter split-adjusted prices?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion7" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon"> No, you just have to enter your actual purchase and sell prices. The system will apply the relevant split factors.</p>
          </b-card-body>
        </b-collapse>



         <b-card-header header-tag="header" class="p-1" role="tab" v-if="!userDetails.isBrokerUser">
         <p block href="#" v-b-toggle.accordion9 class="mb-0 p-2"><span class="faqsWidth">Why does it say "We do not support short selling transactions, please exclude them or include the corresponding Buy transaction too"?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion9" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon"> The analysis does not consider short selling. Please make sure you have included the corresponding buy transaction for each sell. The sell quantity for a stock should be less than or equal to the buy quantity of the stock. Also, make sure the buy transaction date is older than its sell transaction date.</p>
          </b-card-body>
        </b-collapse>



         <b-card-header header-tag="header" class="p-1" role="tab" v-if="!userDetails.isBrokerUser">
         <p block href="#" v-b-toggle.accordion10 class="mb-0 p-2"><span class="faqsWidth"> Is there any transaction cost that you consider while calculating Profit/Loss?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion10" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon"> No, we do not consider transaction costs into account in our calculations.</p>
          </b-card-body>
        </b-collapse>



         <b-card-header header-tag="header" class="p-1" role="tab" v-if="!userDetails.isBrokerUser">
         <p block href="#" v-b-toggle.accordion11 class="mb-0 p-2"><span class="faqsWidth"> What is the rationale for increasing or decreasing allocation in a particular stock?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion11" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon"> Portfolio allocation models are used to figure out the best allocation for each stock in the portfolio.</p>
          </b-card-body>
        </b-collapse>



         <b-card-header header-tag="header" class="p-1" role="tab" v-if="!userDetails.isBrokerUser">
         <p block href="#" v-b-toggle.accordion12 class="mb-0 p-2"><span class="faqsWidth"> The report asks me to sell certain stocks. Which stocks should I buy now?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion12" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon">The tool detects underperforming equities that are showing technical weakness and suggests a SELL recommendation on them. You will also be advised to REDUCE if you are over-invested in a single stock, and this will result in a cash balance. You can subscribe to our Model Portfolio or QuantSmith to find out which stock to buy.</p>
          </b-card-body>
        </b-collapse>



         <b-card-header header-tag="header" class="p-1" role="tab" v-if="!userDetails.isBrokerUser">
         <p block href="#" v-b-toggle.accordion13 class="mb-0 p-2"><span class="faqsWidth">How often do the recommendations change?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion13" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon"> There is no fixed time period for updating recommendations. Since technical factors such as price & volume actions, moving averages etc. are used along with the fundamental factors; the recommendations can change as early as one day or continue to remain the same for a longer duration too.</p>
          </b-card-body>
        </b-collapse>


 <b-card-header header-tag="header" class="p-1" role="tab" v-if="!userDetails.isBrokerUser">
         <p block href="#" v-b-toggle.accordion14 class="mb-0 p-2"><span class="faqsWidth">Why is the performance section blank?</span>
             <span class="when-opened">
                <i class="fa fa-chevron-down" aria-hidden="true"></i>
              </span>
              <span class="when-closed">
                <i class="fa fa-chevron-up" aria-hidden="true"></i>
              </span>

          </p>

        </b-card-header>
        <b-collapse id="accordion14" visible accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <p class="font14  mt-2 text-algo-icon">The performance section includes best winners/inclusions and worst losers/exclusions. This is determined by taking into account the position you have closed, and this column will not appear if you have not entered any closed position/sell transactions.</p>
          </b-card-body>
        </b-collapse>



         
        
        
        
        </div>
   

   </div>
   </b-container> 
   </div>
 </template>
 <script> 
  export default {
    computed: {
        userDetails () {
            return this.$store.state.authentication.user
        }
    },
     created(){
     window.scrollTo(0, 0);
  }
};
 </script>


// WEBPACK FOOTER //
// src/components/faqs.vue